import React from 'react';
import styled from 'styled-components';

import { px } from '../common';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export const FlashPayLogo = ({ ...props }: IconProps) => (
  <svg viewBox="0 0 180 82" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121.478 51.5801H120.114L118.908 57.3401H120.152L120.343 56.5413C120.495 56.8438 120.686 57.0713 120.916 57.2238C121.148 57.3738 121.42 57.4488 121.733 57.4488C122.349 57.4488 122.851 57.2263 123.238 56.7813C123.625 56.3338 123.819 55.7551 123.819 55.0451C123.819 54.5026 123.68 54.0726 123.403 53.7551C123.126 53.4376 122.753 53.2788 122.283 53.2788C122.031 53.2788 121.796 53.3301 121.579 53.4326C121.362 53.5326 121.159 53.6851 120.972 53.8901L121.478 51.5801ZM122.22 54.5201C122.344 54.6626 122.407 54.8551 122.407 55.0976C122.407 55.4676 122.309 55.7826 122.115 56.0426C121.922 56.3026 121.69 56.4326 121.418 56.4326C121.196 56.4326 121.018 56.3576 120.886 56.2076C120.754 56.0551 120.687 55.8513 120.687 55.5963C120.687 55.2463 120.79 54.9438 120.995 54.6888C121.202 54.4338 121.445 54.3063 121.725 54.3063C121.932 54.3063 122.097 54.3776 122.22 54.5201Z"
      fill="#00B3FB"
    />
    <path
      d="M125.793 53.3913H124.422L125.302 57.3701C125.217 57.5801 125.101 57.7376 124.954 57.8426C124.807 57.9476 124.629 58.0001 124.422 58.0001C124.332 58.0001 124.24 57.9888 124.145 57.9663C124.05 57.9438 123.95 57.9088 123.845 57.8613L123.523 58.8213C123.73 58.8888 123.92 58.9388 124.092 58.9713C124.265 59.0063 124.426 59.0238 124.576 59.0238C124.98 59.0238 125.317 58.9326 125.587 58.7501C125.857 58.5676 126.135 58.2301 126.422 57.7376L128.955 53.3913H127.52L126.538 55.2138C126.484 55.3163 126.424 55.4388 126.359 55.5813C126.294 55.7238 126.226 55.8801 126.156 56.0501C126.134 55.7576 126.093 55.4063 126.033 54.9963V54.9813L125.793 53.3913Z"
      fill="#00B3FB"
    />
    <path
      d="M135.446 53.1701L135.776 52.1313C135.563 52.0538 135.306 51.9951 135.004 51.9551C134.704 51.9151 134.369 51.8951 133.996 51.8951C133.327 51.8951 132.787 52.0563 132.375 52.3788C131.962 52.6988 131.756 53.1163 131.756 53.6313C131.756 53.9238 131.83 54.1738 131.977 54.3813C132.125 54.5888 132.35 54.7563 132.652 54.8838C132.729 54.9163 132.838 54.9601 132.978 55.0151C133.534 55.2376 133.813 55.4776 133.813 55.7351C133.813 55.9401 133.708 56.1026 133.498 56.2226C133.289 56.3426 133.001 56.4026 132.637 56.4026C132.437 56.4026 132.232 56.3751 132.022 56.3201C131.815 56.2651 131.6 56.1826 131.378 56.0726L131.071 57.1713C131.346 57.2688 131.63 57.3413 131.925 57.3888C132.222 57.4388 132.532 57.4638 132.854 57.4638C133.616 57.4638 134.219 57.2913 134.663 56.9463C135.108 56.5988 135.33 56.1338 135.33 55.5513C135.33 55.2338 135.25 54.9726 135.09 54.7676C134.93 54.5626 134.63 54.3526 134.188 54.1376C134.1 54.0951 133.98 54.0426 133.828 53.9801C133.448 53.8226 133.259 53.6476 133.259 53.4551C133.259 53.2776 133.342 53.1426 133.51 53.0501C133.679 52.9551 133.923 52.9076 134.24 52.9076C134.45 52.9076 134.654 52.9301 134.854 52.9751C135.054 53.0176 135.251 53.0826 135.446 53.1701Z"
      fill="#00B3FB"
    />
    <path
      d="M138.342 52.0113H136.929L135.794 57.3401H137.214L137.757 54.7751L139.046 57.3401H140.694L139.14 54.5913L141.548 52.0888L142.814 55.3263L142.417 57.3401H143.829L144.256 55.3263L146.89 52.0113H145.23L144.11 53.5451C144.075 53.5951 144.023 53.6763 143.953 53.7888C143.883 53.8988 143.806 54.0251 143.721 54.1676C143.691 54.0476 143.658 53.9201 143.623 53.7851C143.591 53.6501 143.572 53.5751 143.567 53.5601L143.069 52.0113H139.829L137.881 54.1976L138.342 52.0113Z"
      fill="#00B3FB"
    />
    <path
      d="M153.76 53.2863L154.112 52.2026C153.787 52.0976 153.475 52.0188 153.175 51.9663C152.876 51.9138 152.583 51.8876 152.299 51.8876C151.752 51.8876 151.279 51.9626 150.879 52.1126C150.482 52.2601 150.127 52.4951 149.815 52.8176C149.555 53.0851 149.352 53.4076 149.205 53.7851C149.06 54.1626 148.987 54.5538 148.987 54.9588C148.987 55.7438 149.221 56.3576 149.688 56.8001C150.157 57.2426 150.81 57.4638 151.647 57.4638C151.877 57.4638 152.113 57.4463 152.355 57.4113C152.597 57.3788 152.848 57.3301 153.108 57.2651L153.243 56.0351C153.023 56.1451 152.807 56.2276 152.595 56.2826C152.385 56.3376 152.176 56.3651 151.969 56.3651C151.502 56.3651 151.132 56.2426 150.86 55.9976C150.588 55.7501 150.452 55.4163 150.452 54.9963C150.452 54.3513 150.632 53.8476 150.991 53.4851C151.351 53.1201 151.852 52.9376 152.493 52.9376C152.733 52.9376 152.957 52.9663 153.164 53.0238C153.374 53.0813 153.572 53.1688 153.76 53.2863Z"
      fill="#00B3FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.88 52.0113H154.872L153.745 57.3401H155.138L155.584 55.2213H155.838C156.041 55.2213 156.188 55.2513 156.281 55.3113C156.375 55.3713 156.44 55.4763 156.475 55.6263L156.85 57.3401H158.247L157.854 55.5288C157.806 55.2963 157.743 55.1201 157.663 55.0001C157.583 54.8776 157.47 54.7713 157.326 54.6813C157.793 54.6438 158.153 54.5076 158.408 54.2726C158.663 54.0376 158.79 53.7238 158.79 53.3313C158.79 52.8938 158.63 52.5651 158.311 52.3451C157.991 52.1226 157.514 52.0113 156.88 52.0113ZM155.794 54.2313L156.045 52.9863H156.599C156.841 52.9863 157.023 53.0326 157.146 53.1251C157.271 53.2176 157.333 53.3551 157.333 53.5376C157.333 53.7576 157.243 53.9288 157.063 54.0513C156.884 54.1713 156.629 54.2313 156.299 54.2313H155.794Z"
      fill="#00B3FB"
    />
    <path
      d="M160.794 52.0113H159.243L160.54 55.3263L160.142 57.3401H161.555L161.982 55.3263L164.615 52.0113H162.956L161.836 53.5451C161.801 53.5951 161.748 53.6763 161.678 53.7888C161.608 53.8988 161.531 54.0251 161.446 54.1676C161.416 54.0476 161.384 53.9201 161.349 53.7851C161.316 53.6501 161.297 53.5751 161.292 53.5601L160.794 52.0113Z"
      fill="#00B3FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.731 52.0113H165.158L164.031 57.3401H165.443L165.866 55.3976C166.031 55.4051 166.176 55.4113 166.301 55.4163C166.428 55.4188 166.535 55.4201 166.623 55.4201C167.337 55.4201 167.898 55.2451 168.305 54.8951C168.712 54.5451 168.915 54.0651 168.915 53.4551C168.915 52.9601 168.738 52.5963 168.383 52.3638C168.031 52.1288 167.481 52.0113 166.731 52.0113ZM166.072 54.4001L166.368 52.9713H166.698C166.967 52.9713 167.173 53.0251 167.316 53.1326C167.458 53.2401 167.529 53.3963 167.529 53.6013C167.529 53.8513 167.434 54.0476 167.245 54.1901C167.055 54.3301 166.789 54.4001 166.447 54.4001H166.072Z"
      fill="#00B3FB"
    />
    <path
      d="M173.71 52.0113H169.589L169.376 53.0388H170.695L169.781 57.3401H171.215L172.129 53.0388H173.489L173.71 52.0113Z"
      fill="#00B3FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M178.31 52.4951C177.895 52.0901 177.32 51.8876 176.583 51.8876C176.054 51.8876 175.583 51.9913 175.171 52.1988C174.759 52.4063 174.4 52.7201 174.096 53.1401C173.906 53.4001 173.759 53.7063 173.654 54.0588C173.551 54.4113 173.5 54.7776 173.5 55.1576C173.5 55.8826 173.707 56.4501 174.122 56.8601C174.539 57.2676 175.118 57.4713 175.86 57.4713C176.357 57.4713 176.81 57.3701 177.22 57.1676C177.632 56.9626 177.983 56.6663 178.272 56.2788C178.477 56.0013 178.638 55.6776 178.756 55.3076C178.873 54.9351 178.932 54.5576 178.932 54.1751C178.932 53.4576 178.724 52.8976 178.31 52.4951ZM177.209 53.1963C177.378 53.4088 177.463 53.7101 177.463 54.1001C177.463 54.3726 177.425 54.6526 177.347 54.9401C177.27 55.2276 177.169 55.4701 177.044 55.6676C176.874 55.9251 176.697 56.1163 176.512 56.2413C176.327 56.3638 176.126 56.4251 175.909 56.4251C175.609 56.4251 175.373 56.3176 175.201 56.1026C175.028 55.8851 174.942 55.5888 174.942 55.2138C174.942 54.9388 174.981 54.6576 175.058 54.3701C175.136 54.0801 175.237 53.8338 175.362 53.6313C175.514 53.3838 175.685 53.1963 175.875 53.0688C176.067 52.9413 176.272 52.8776 176.489 52.8776C176.799 52.8776 177.039 52.9838 177.209 53.1963Z"
      fill="#00B3FB"
    />
    <path
      d="M3.7833 28.6062H15.6451L14.9334 31.9062H7.76639L6.97976 35.7437H13.8347L13.1354 39.0687H6.25556L4.73225 46.3687H0L3.7833 28.6062Z"
      fill="#1D1D1D"
    />
    <path
      d="M18.7043 28.6062H23.4865L20.4398 42.8312H27.7817L27.0075 46.3687H14.921L18.7043 28.6062Z"
      fill="#1D1D1D"
    />
    <path
      d="M40.3677 32.0812L36.4346 39.2312H41.2168L40.3677 32.0812ZM37.9954 28.6062H43.8763L46.7357 46.3687H42.0284L41.5664 42.5812H34.6116L32.489 46.3687H27.507L37.9954 28.6062Z"
      fill="#1D1D1D"
    />
    <path
      d="M63.567 29.0062L62.4682 32.4688C61.8189 32.1771 61.1613 31.9604 60.4954 31.8187C59.8295 31.6687 59.1469 31.5938 58.4477 31.5938C57.3905 31.5938 56.5789 31.7521 56.0129 32.0687C55.4552 32.3771 55.1763 32.8271 55.1763 33.4187C55.1763 34.0604 55.8089 34.6437 57.0742 35.1687C57.582 35.3771 57.9815 35.5521 58.2729 35.6937C59.7462 36.4104 60.7493 37.1104 61.282 37.7937C61.8148 38.4771 62.0812 39.3479 62.0812 40.4062C62.0812 42.3479 61.3403 43.8979 59.8586 45.0562C58.3769 46.2062 56.3667 46.7812 53.8278 46.7812C52.754 46.7812 51.7218 46.6979 50.7312 46.5312C49.749 46.3729 48.8 46.1313 47.8844 45.8062L48.9083 42.1437C49.6491 42.5104 50.365 42.7854 51.0559 42.9688C51.7551 43.1521 52.4377 43.2437 53.1036 43.2437C54.3189 43.2437 55.2762 43.0437 55.9754 42.6437C56.6746 42.2437 57.0243 41.7021 57.0243 41.0187C57.0243 40.1604 56.0961 39.3604 54.2398 38.6187C53.7737 38.4354 53.4116 38.2896 53.1535 38.1812C52.1463 37.7562 51.3972 37.1979 50.906 36.5062C50.4149 35.8146 50.1694 34.9812 50.1694 34.0062C50.1694 32.2896 50.8561 30.8979 52.2296 29.8312C53.6031 28.7562 55.4052 28.2188 57.6361 28.2188C58.8764 28.2188 59.996 28.2854 60.9949 28.4187C62.0021 28.5521 62.8595 28.7479 63.567 29.0062Z"
      fill="#1D1D1D"
    />
    <path
      d="M67.3878 28.6062H72.2199L70.809 35.2812H76.3029L77.7388 28.6062H82.5709L78.8126 46.3687H73.9555L75.5662 38.8438H70.0473L68.4616 46.3687H63.6294L67.3878 28.6062Z"
      fill="#1D1D1D"
    />
    <g filter="url(#filter0_d_4661_3958)">
      <path
        d="M85.1289 41.9766L122.847 32.3799L93.4397 69.4999L108.783 41.9766H85.1289Z"
        fill="url(#paint0_linear_4661_3958)"
      />
    </g>
    <g filter="url(#filter1_d_4661_3958)">
      <path
        d="M122.848 32.38L85.1295 41.98L114.537 4.85998L99.1933 32.38H122.848Z"
        fill="url(#paint1_linear_4661_3958)"
      />
    </g>
    <g filter="url(#filter2_d_4661_3958)">
      <path
        d="M99.1922 32.3799L114.535 4.85988L105.585 32.3799H99.1922Z"
        fill="url(#paint2_linear_4661_3958)"
      />
    </g>
    <g filter="url(#filter3_d_4661_3958)">
      <path
        d="M108.782 41.98L93.4395 69.5L102.39 41.98H108.782Z"
        fill="url(#paint3_linear_4661_3958)"
      />
    </g>
    <path
      d="M133.401 31.8187L132.414 36.5812H133.663C134.803 36.5812 135.69 36.3478 136.322 35.8812C136.955 35.4062 137.271 34.752 137.271 33.9187C137.271 33.2353 137.034 32.7145 136.56 32.3562C136.085 31.9978 135.399 31.8187 134.5 31.8187H133.401ZM129.368 28.6187H134.612C137.109 28.6187 138.945 29.0103 140.118 29.7937C141.3 30.5687 141.891 31.7812 141.891 33.4312C141.891 35.4645 141.213 37.0645 139.856 38.2312C138.499 39.3978 136.63 39.9812 134.25 39.9812C133.958 39.9812 133.601 39.977 133.176 39.9687C132.76 39.952 132.277 39.9312 131.728 39.9062L130.317 46.3812H125.609L129.368 28.6187Z"
      fill="#1D1D1D"
    />
    <path
      d="M152.242 32.0937L148.309 39.2437H153.091L152.242 32.0937ZM149.87 28.6187H155.751L158.61 46.3812H153.903L153.441 42.5937H146.486L144.364 46.3812H139.382L149.87 28.6187Z"
      fill="#1D1D1D"
    />
    <path
      d="M161.295 28.6187H166.464L168.125 33.7812C168.141 33.8312 168.204 34.0812 168.312 34.5312C168.429 34.9812 168.537 35.4062 168.637 35.8062C168.92 35.3312 169.178 34.9103 169.411 34.5437C169.644 34.1687 169.819 33.8978 169.935 33.7312L173.669 28.6187H179.2L170.422 39.6687L168.999 46.3812H164.291L165.615 39.6687L161.295 28.6187Z"
      fill="#1D1D1D"
    />
    <defs>
      <filter
        id="filter0_d_4661_3958"
        x="79.1289"
        y="28.3799"
        width="53.7188"
        height="53.1201"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4661_3958"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4661_3958"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_4661_3958"
        x="79.1289"
        y="0.859863"
        width="53.7188"
        height="53.1201"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4661_3958"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4661_3958"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_4661_3958"
        x="93.1914"
        y="0.859863"
        width="31.3438"
        height="43.52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4661_3958"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4661_3958"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_4661_3958"
        x="87.4395"
        y="37.98"
        width="31.3438"
        height="43.52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4661_3958"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4661_3958"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4661_3958"
        x1="122.847"
        y1="32.3799"
        x2="93.3842"
        y2="69.4558"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#527591" />
        <stop offset="1" stopColor="#00B3FB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4661_3958"
        x1="85.1295"
        y1="41.98"
        x2="114.6"
        y2="4.91054"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#D6EEF9" />
        <stop offset="0.479012" stopColor="#00B3FB" />
        <stop offset="1" stopColor="#527591" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4661_3958"
        x1="105.585"
        y1="32.3799"
        x2="114.553"
        y2="4.86574"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#527591" />
        <stop offset="1" stopColor="#4E7491" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4661_3958"
        x1="109.508"
        y1="41.839"
        x2="93.5686"
        y2="69.6798"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B3FB" />
        <stop offset="1" stopColor="#D6EEF9" />
      </linearGradient>
    </defs>
  </svg>
);

export const ToMessageIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68691 7.68694 0.000831175 11.7565 0 16C0 20.2418 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2418 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z"
      fill="#00B3FB"
    />
    <path
      d="M7.2425 15.831C11.9075 13.799 15.0175 12.4593 16.5725 11.812C21.0175 9.96375 21.94 9.64275 22.5425 9.63188C22.675 9.62975 22.97 9.6625 23.1625 9.81813C23.3225 9.94938 23.3675 10.1269 23.39 10.2515C23.41 10.376 23.4375 10.6598 23.415 10.8813C23.175 13.4113 22.1325 19.5508 21.6025 22.3845C21.38 23.5835 20.9375 23.9855 20.51 24.0247C19.58 24.1103 18.875 23.4107 17.975 22.821C16.5675 21.8977 15.7725 21.3233 14.405 20.4225C12.825 19.3815 13.85 18.8092 14.75 17.8743C14.985 17.6295 19.08 13.9058 19.1575 13.568C19.1675 13.5258 19.1775 13.3683 19.0825 13.2853C18.99 13.202 18.8525 13.2305 18.7525 13.253C18.61 13.285 16.3625 14.772 12.0025 17.7138C11.365 18.1523 10.7875 18.366 10.2675 18.3547C9.6975 18.3425 8.5975 18.0318 7.78 17.7663C6.78 17.4405 5.9825 17.2683 6.0525 16.715C6.0875 16.427 6.485 16.1323 7.2425 15.831Z"
      fill="white"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="24" height="24" rx="12" fill="#00B3FB" />
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="14"
      stroke="#00B3FB"
      strokeOpacity="0.16"
      strokeWidth="4"
    />
    <path
      d="M16.01 16V21M16 11H16.01"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LikeIcon = ({
  size,
  fill,
  flip,
}: {
  size: number | string;
  fill: string;
  flip?: boolean;
}) => (
  <LikeIconRoot
    size={size}
    viewBox={'0 0 511.999 511.999'}
    fill={fill}
    className={flip ? 'flip' : ''}>
    <path
      d="M83.578,167.256H16.716C7.524,167.256,0,174.742,0,183.971v300.881c0,9.225,7.491,16.713,16.716,16.713h66.862
		c9.225,0,16.716-7.489,16.716-16.713V183.971C100.294,174.742,92.769,167.256,83.578,167.256z"
    />
    <path
      d="M470.266,167.256c-2.692-0.456-128.739,0-128.739,0l17.606-48.032c12.148-33.174,4.283-83.827-29.424-101.835
		c-10.975-5.864-26.309-8.809-38.672-5.697c-7.09,1.784-13.321,6.478-17.035,12.767c-4.271,7.233-3.83,15.676-5.351,23.696
		c-3.857,20.342-13.469,39.683-28.354,54.2c-25.952,25.311-106.571,98.331-106.571,98.331v267.45h278.593
		c37.592,0.022,62.228-41.958,43.687-74.749c22.101-14.155,29.66-43.97,16.716-66.862c22.102-14.155,29.66-43.97,16.716-66.862
		C527.572,235.24,514.823,174.792,470.266,167.256z"
    />
  </LikeIconRoot>
);

export const LockIcon = ({ size, fill }: { size: number | string; fill: string }) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 512 512'} fill={fill}>
    <path
      d="M400,188h-36.037v-82.23c0-58.322-48.449-105.77-108-105.77c-59.551,0-108,47.448-108,105.77V188H112
			c-33.084,0-60,26.916-60,60v204c0,33.084,26.916,60,60,60h288c33.084,0,60-26.916,60-60V248C460,214.916,433.084,188,400,188z
			M187.963,105.77c0-36.266,30.505-65.77,68-65.77s68,29.504,68,65.77V188h-136V105.77z M420,452c0,11.028-8.972,20-20,20H112
			c-11.028,0-20-8.972-20-20V248c0-11.028,8.972-20,20-20h288c11.028,0,20,8.972,20,20V452z"
    />
    <path
      d="M256,286c-20.435,0-37,16.565-37,37c0,13.048,6.76,24.51,16.963,31.098V398c0,11.045,8.954,20,20,20
            c11.045,0,20-8.955,20-20v-43.855C286.207,347.565,293,336.08,293,323C293,302.565,276.435,286,256,286z"
    />
  </svg>
);

export const AnonymousIcon = ({
  size,
  fill,
}: {
  size: number | string;
  fill: string;
}) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 512 512'} fill={fill}>
    <path
      d="M418.88,344.043l-54.869-19.093c-3.989-1.408-8.491-0.277-11.371,2.859c-26.901,29.355-61.227,45.525-96.64,45.525
			s-69.739-16.171-96.64-45.525c-2.901-3.136-7.36-4.245-11.371-2.859L93.12,344.043C37.419,363.413,0,416.043,0,475.008v15.659
			c0,5.888,4.779,10.667,10.667,10.667h490.667c5.888,0,10.667-4.779,10.667-10.667v-15.659
			C512,416.021,474.581,363.392,418.88,344.043z M490.667,480H21.333v-4.992c0-49.899,31.659-94.443,78.784-110.827l48.384-16.832
			c30.251,30.571,68.181,47.317,107.499,47.317s77.248-16.747,107.499-47.317l48.384,16.832
			c47.125,16.384,78.784,60.928,78.784,110.827V480z"
    />
    <path
      d="M383.936,141.44c0.043-0.917,0.064-1.856,0.064-2.773c0-70.592-57.408-128-128-128s-128,57.408-128,128
			c0,0.917,0.021,1.856,0.064,2.773c-12.715,6.955-21.397,26.389-21.397,50.56c0,29.675,13.099,52.224,30.677,53.291
			C156.736,309.547,203.435,352,256,352s99.264-42.453,118.656-106.709c17.579-1.067,30.677-23.616,30.677-53.291
			C405.333,167.829,396.651,148.395,383.936,141.44z M372.672,223.531c-2.901-1.792-6.464-2.091-9.643-0.811
			c-3.136,1.28-5.483,3.989-6.315,7.296C341.781,290.219,301.312,330.667,256,330.667s-85.781-40.448-100.715-100.651
			c-0.832-3.307-3.499-5.76-6.656-7.061c-1.173-0.491-2.453-0.704-3.755-0.704c-2.176,0-4.395,0.619-6.208,1.749
			C136,224,128,212.651,128,192c0-19.563,7.189-30.763,10.197-31.915c0.107,0.021,0.235,0.043,0.32,0.043
			c3.136,0.235,6.357-0.811,8.619-3.072c2.261-2.283,3.392-5.461,3.051-8.64l-0.299-2.667c-0.256-2.347-0.555-4.672-0.555-7.083
			C149.333,79.851,197.184,32,256,32s106.667,47.851,106.667,106.667c0,2.411-0.299,4.736-0.555,7.061l-0.299,2.667
			c-0.32,3.2,0.789,6.379,3.051,8.64c2.283,2.283,5.461,3.349,8.619,3.093c0.085-0.021,0.213-0.021,0.32-0.043
			C376.811,161.237,384,172.437,384,192C384,212.651,376.171,224,372.672,223.531z"
    />
    <path
      d="M256,96c-25.131,0-42.667,17.536-42.667,42.667c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667
			c0-19.243,14.912-21.333,21.333-21.333s21.333,2.091,21.333,21.333c0,17.899-3.947,26.069-16.235,33.557
			c-23.723,14.507-27.691,33.685-26.304,42.731c0.811,5.248,5.291,8.853,10.453,8.853c0.427,0,0.875-0.043,1.323-0.085
			c5.696-0.661,9.813-5.931,9.344-11.669c-0.021-0.448-0.704-11.221,16.32-21.611c18.773-11.477,26.432-26.475,26.432-51.776
			C298.667,113.536,281.131,96,256,96z"
    />
    <circle cx="245.333" cy="256" r="10.667" />
  </svg>
);

export const ShieldIcon = ({ size, fill }: { size: number | string; fill: string }) => (
  <ShieldIconSvg size={size} viewBox={'0 0 512 512'} fill={fill}>
    <path
      d="M461.144,60.883L260.312,0.633c-2.809-0.844-5.808-0.844-8.62,0L50.858,60.883c-6.345,1.903-10.69,7.743-10.69,14.367
			v220.916c0,28.734,11.632,58.148,34.573,87.425c17.522,22.36,41.762,44.813,72.048,66.736
			c50.877,36.828,100.975,59.42,103.083,60.363c1.95,0.873,4.039,1.31,6.129,1.31c2.089,0,4.179-0.436,6.129-1.31
			c2.108-0.943,52.205-23.535,103.082-60.363c30.285-21.923,54.525-44.376,72.047-66.736c22.941-29.276,34.573-58.69,34.573-87.425
			V75.25C471.833,68.626,467.489,62.786,461.144,60.883z M441.833,296.166c0,50.852-51.023,98.534-93.826,129.581
			c-38.374,27.833-77.291,47.583-92.005,54.678c-14.714-7.095-53.632-26.845-92.006-54.678
			c-42.804-31.047-93.828-78.729-93.828-129.581V86.41l185.833-55.75l185.832,55.75V296.166z"
    />
  </ShieldIconSvg>
);

export const SearchBitcoinIcon = ({
  size,
  fill,
}: {
  size: number | string;
  fill: string;
}) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 512 512'} fill={fill}>
    <path d="M392.876,359.415l-33.564,33.564,71.631,71.632a23.734,23.734,0,0,0,33.565-33.565Z" />
    <rect
      x="347.496"
      y="330.717"
      width="14"
      height="47.353"
      transform="translate(-146.764 354.466) rotate(-45)"
    />
    <path d="M249.834,242.5A26.52,26.52,0,0,0,223.4,216H184v53h39.4A26.52,26.52,0,0,0,249.834,242.5Z" />
    <path d="M249.834,176A26.1,26.1,0,0,0,223.4,150H184v52h39.4A26.1,26.1,0,0,0,249.834,176Z" />
    <path d="M348.911,209.6c0-76.762-62.451-139.212-139.212-139.212S70.488,132.835,70.488,209.6,132.938,348.808,209.7,348.808,348.911,286.358,348.911,209.6ZM199,298V283H188v15a7,7,0,0,1-14,0V283H159.861a7,7,0,0,1,0-14H170V150H159.861a7,7,0,0,1,0-14H174V120a7,7,0,0,1,14,0v16h11V120a7,7,0,0,1,14,0v16h10.4a40.143,40.143,0,0,1,22.712,73.442A40.218,40.218,0,0,1,223.4,283H213v15a7,7,0,0,1-14,0Z" />
    <path d="M378.853,209.6c0-93.272-75.882-169.154-169.154-169.154S40.546,116.325,40.546,209.6,116.428,378.75,209.7,378.75,378.853,302.868,378.853,209.6Zm-322.365,0c0-84.481,68.73-153.212,153.211-153.212S362.911,125.116,362.911,209.6,294.18,362.808,209.7,362.808,56.488,294.078,56.488,209.6Z" />
  </svg>
);

export const SuccessIcon = ({ size, fill }: { size: number | string; fill: string }) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 594 594'} fill={fill}>
    <path
      d="M448.8,161.925l-35.7-35.7l-160.65,160.65l35.7,35.7L448.8,161.925z M555.899,126.225l-267.75,270.3l-107.1-107.1
			l-35.7,35.7l142.8,142.8l306-306L555.899,126.225z M0,325.125l142.8,142.8l35.7-35.7l-142.8-142.8L0,325.125z"
    />
  </svg>
);

export const OkIcon = ({ size = 20 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1503_326)">
      <path
        d="M18.3332 9.23355V10.0002C18.3321 11.7972 17.7503 13.5458 16.6743 14.9851C15.5983 16.4244 14.0859 17.4773 12.3626 17.9868C10.6394 18.4963 8.79755 18.4351 7.1119 17.8124C5.42624 17.1896 3.98705 16.0386 3.00897 14.5311C2.03089 13.0236 1.56633 11.2403 1.68457 9.44714C1.80281 7.65402 2.49751 5.94715 3.66507 4.58111C4.83263 3.21506 6.41049 2.26303 8.16333 1.867C9.91617 1.47097 11.7501 1.65216 13.3915 2.38355"
        stroke="#59B783"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 3.3335L10 11.6752L7.5 9.17516"
        stroke="#59B783"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const BigOkIcon = () => (
  <svg
    width="83"
    height="83"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.3333 74.6667C59.7428 74.6667 74.6667 59.7428 74.6667 41.3333C74.6667 22.9238 59.7428 8 41.3333 8C22.9238 8 8 22.9238 8 41.3333C8 59.7428 22.9238 74.6667 41.3333 74.6667Z"
      fill="#4CD964"
      stroke="#1EE0A1"
      strokeOpacity="0.16"
      strokeWidth="16"
      strokeLinecap="round"
    />
    <path
      d="M54.3327 31L35.9993 49.3333L27.666 41"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const DisputeIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="64" height="64" rx="32" fill="#FF9500" />
    <rect
      x="8"
      y="8"
      width="64"
      height="64"
      rx="32"
      stroke="#FD7E14"
      strokeOpacity="0.16"
      strokeWidth="16"
    />
    <path
      d="M36.6268 54.4815H32.0713C31.519 54.4815 31.0713 54.9292 31.0713 55.4815V56.3333H49.5898V55.4815C49.5898 54.9292 49.1421 54.4815 48.5898 54.4815H44.0343M36.6268 54.4815L38.6639 53M36.6268 54.4815H44.0343M38.6639 53H41.9972M38.6639 53L39.4977 32.1667M44.0343 54.4815L41.9972 53M41.9972 53L41.1643 32.1667M28.6661 29.6663L22 44.6667M28.6661 29.6663L35.3333 44.6667M28.6661 29.6663L26.9998 29.6667M28.6661 29.6663H36.9976M51.9978 29.6667L58.6651 44.6667M51.9978 29.6667L45.3318 44.6667M51.9978 29.6667H53.6649M51.9978 29.6667H43.6643M22 44.6667C22 44.6667 22.8316 47.1667 28.6657 47.1667C34.4998 47.1667 35.3333 44.6667 35.3333 44.6667M22 44.6667H35.3333M58.6651 44.6667C58.6651 44.6667 57.8317 47.1667 51.9978 47.1667C46.1639 47.1667 45.3318 44.6667 45.3318 44.6667M58.6651 44.6667H45.3318M40.3306 26.3333C39.4101 26.3333 38.6639 25.5871 38.6639 24.6667C38.6639 23.7462 39.4101 23 40.3306 23C41.251 23 41.9972 23.7462 41.9972 24.6667C41.9972 25.5871 41.251 26.3333 40.3306 26.3333ZM40.3306 26.3333L43.6643 29.6667M40.3306 26.3333L36.9976 29.6663M43.6643 29.6667L40.331 33L36.9976 29.6663M40.331 28C41.2513 28.0001 41.9972 28.7463 41.9972 29.6667C41.9972 30.5871 41.251 31.3335 40.3306 31.3333C39.4102 31.3332 38.6643 30.587 38.6643 29.6667C38.6643 28.7462 39.4105 27.9999 40.331 28Z"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const BigNotOkIcon = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.9994 75.3333C60.4088 75.3333 75.3327 60.4095 75.3327 42C75.3327 23.5905 60.4088 8.66663 41.9994 8.66663C23.5899 8.66663 8.66602 23.5905 8.66602 42C8.66602 60.4095 23.5899 75.3333 41.9994 75.3333Z"
      fill="#E81D11"
      stroke="#E81D11"
      strokeOpacity="0.16"
      strokeWidth="16"
      strokeLinecap="round"
    />
    <path
      d="M53 31L31 53M31 31L53 53"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const AttentionIcon = ({ size = 20, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_1503_274)">
      <path
        d="M9.99996 18.3334C14.6023 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6023 1.66675 9.99996 1.66675C5.39759 1.66675 1.66663 5.39771 1.66663 10.0001C1.66663 14.6025 5.39759 18.3334 9.99996 18.3334Z"
        stroke={props.color ?? '#0098DB'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.3333V10"
        stroke={props.color ?? '#0098DB'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66675H10.0083"
        stroke={props.color ?? '#0098DB'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const BitcoinIcon = ({ size = 42, ...props }: IconProps) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 48 48'} {...props}>
    <rect width="48" height="48" rx="4" fill="#F58B41" />
    <path
      d="M20.0056 12V16H16V18.6667C16 18.6667 17.5297 18.64 17.5053 18.6667C18.3242 18.6543 18.585 19.2481 18.6698 19.6441V28.4444C18.6384 28.6947 18.6651 29.3156 18.0928 29.3333C18.1192 29.3564 16 29.3333 16 29.3333V32H18.8958C19.3854 31.9822 19.5325 32 20.0056 32V36H22.6759V32H23.9833L24.0389 36H26.6815L26.6537 32C30.0494 31.7538 32.0223 30.1305 31.9998 27.3333C32.0223 24.7601 29.9616 23.3419 28.6843 23.3333C29.9614 23.3384 30.6871 21.9513 30.6871 20C30.6871 17.3333 28.8443 16 26.6815 16V12H24.0111V16C23.4796 16 23.2156 15.9804 22.6759 16V12H20.0056ZM22.6759 18.6667C25.3463 18.6667 26.6815 18.6667 26.6815 20.6667C26.6815 22.6667 25.3463 22.6667 22.6759 22.6667V18.6667ZM22.6759 25.3333C26.2357 25.3334 28.0171 25.1111 28.0167 27.3333C28.0171 29.5557 26.2357 29.3333 22.6759 29.3333V25.3333Z"
      fill="white"
    />
  </svg>
);

export const YouTubeIcon = ({ color, ...props }: IconProps) => (
  <svg viewBox="0 0 32 24" fill="none" {...props}>
    <path
      d="M31.9964 12.6244C31.9875 13.3978 31.962 14.1629 31.92 14.9198C31.8667 15.7198 31.7933 16.5598 31.7 17.4398C31.6067 18.3198 31.48 19.0665 31.32 19.6798C31.1333 20.3731 30.7867 20.9731 30.28 21.4798C29.7733 21.9865 29.1733 22.3331 28.48 22.5198C27.8667 22.6798 26.8733 22.8065 25.5 22.8998C24.1267 22.9931 22.7333 23.0665 21.32 23.1198C19.6667 23.1731 17.8933 23.1998 16 23.1998H14.36C13.8533 23.1998 13.2733 23.1931 12.62 23.1798C11.9667 23.1665 11.28 23.1465 10.56 23.1198C10.5685 23.1007 10.5769 23.0815 10.5853 23.0623C9.2044 23.0093 7.84264 22.9371 6.5 22.8459C5.12667 22.7525 4.13333 22.6259 3.52 22.4659C2.82667 22.2792 2.22667 21.9325 1.72 21.4259C1.21333 20.9192 0.866667 20.3192 0.68 19.6259C0.52 19.0125 0.393333 18.2659 0.3 17.3859C0.206667 16.5059 0.133333 15.6659 0.08 14.8659C0.0398977 14.144 0.0148723 13.4147 0.00492361 12.6777C0.00328226 12.6784 0.00164106 12.6791 0 12.6798V11.9998C0 11.0131 0.026668 10.0398 0.0800013 9.07981C0.133335 8.27981 0.206669 7.43981 0.300002 6.55981C0.393336 5.67981 0.52 4.93314 0.68 4.31981C0.866667 3.62647 1.21333 3.02647 1.72 2.5198C2.22666 2.01314 2.82667 1.66647 3.52 1.4798C4.13333 1.3198 5.12667 1.19314 6.5 1.0998C7.87333 1.00647 9.26667 0.933138 10.68 0.879805C12.3333 0.826471 14.1067 0.799805 16 0.799805C17.8933 0.799805 19.6667 0.826471 21.32 0.879805C22.7333 0.933138 24.1267 1.00647 25.5 1.0998C26.8733 1.19314 27.8667 1.3198 28.48 1.4798C29.1733 1.66647 29.7733 2.01314 30.28 2.5198C30.7867 3.02647 31.1333 3.62647 31.32 4.31981C31.48 4.93314 31.6067 5.67981 31.7 6.55981C31.7933 7.43981 31.8667 8.27981 31.92 9.07981C31.9733 10.0398 32 11.0131 32 11.9998V12.6259C31.9988 12.6254 31.9976 12.6249 31.9964 12.6244Z"
      fill={color}
    />
    <path d="M12.8008 16.7455L21.1208 11.9455L12.8008 7.14551V16.7455Z" fill="white" />
  </svg>
);

export const TelegramIcon = ({ color, ...props }: IconProps) => (
  <svg viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68691 7.68694 0.000831175 11.7565 0 16C0 20.2418 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2418 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z"
      fill={color}
    />
    <path
      d="M7.2425 15.831C11.9075 13.799 15.0175 12.4593 16.5725 11.812C21.0175 9.96375 21.94 9.64275 22.5425 9.63188C22.675 9.62975 22.97 9.6625 23.1625 9.81813C23.3225 9.94938 23.3675 10.1269 23.39 10.2515C23.41 10.376 23.4375 10.6598 23.415 10.8813C23.175 13.4113 22.1325 19.5508 21.6025 22.3845C21.38 23.5835 20.9375 23.9855 20.51 24.0247C19.58 24.1103 18.875 23.4107 17.975 22.821C16.5675 21.8977 15.7725 21.3233 14.405 20.4225C12.825 19.3815 13.85 18.8092 14.75 17.8743C14.985 17.6295 19.08 13.9058 19.1575 13.568C19.1675 13.5258 19.1775 13.3683 19.0825 13.2853C18.99 13.202 18.8525 13.2305 18.7525 13.253C18.61 13.285 16.3625 14.772 12.0025 17.7138C11.365 18.1523 10.7875 18.366 10.2675 18.3547C9.6975 18.3425 8.5975 18.0318 7.78 17.7663C6.78 17.4405 5.9825 17.2683 6.0525 16.715C6.0875 16.427 6.485 16.1323 7.2425 15.831Z"
      fill="white"
    />
  </svg>
);

export const CopyIcon = ({ size = 24, ...props }: IconProps) => (
  <svg
    style={{ width: size, height: size }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8 5V4C8 3.44772 8.44772 3 9 3H19C19.5523 3 20 3.44772 20 4V16C20 16.5523 19.5523 17 19 17H18M16 20V8C16 7.44772 15.5523 7 15 7H5C4.44772 7 4 7.44772 4 8V20C4 20.5523 4.44772 21 5 21H15C15.5523 21 16 20.5523 16 20Z"
      stroke="#8B959E"
      strokeWidth="1.5"
    />
  </svg>
);

export const EthereumIcon = ({ size = 42, ...props }: IconProps) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 48 48'} {...props}>
    <rect width="48" height="48" rx="6" fill="#527591" />
    <path d="M17 25L24 12L31 25L24 29L17 25Z" fill="white" />
    <path d="M17 26L24 30L31 26L24 36L17 26Z" fill="white" />
  </svg>
);

export const USDTIcon = ({ size = 42, ...props }: IconProps) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 48 48'} {...props}>
    <rect width="48" height="48" rx="6" fill="#26A17B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6436 24.9018V24.8991C26.4956 24.9099 25.7323 24.9558 24.0296 24.9558C22.6701 24.9558 21.7131 24.9153 21.3766 24.8991V24.9032C16.1432 24.6725 12.237 23.7592 12.237 22.6665C12.237 21.5752 16.1432 20.6619 21.3766 20.4272V23.9939C21.7185 24.0182 22.6984 24.0762 24.0525 24.0762C25.6772 24.0762 26.4915 24.0088 26.6436 23.9953V20.4299C31.8662 20.6633 35.763 21.5765 35.763 22.6665C35.763 23.7592 31.8662 24.6698 26.6436 24.9018ZM26.6436 20.0589V16.8672H33.931V12H14.0891V16.8672H21.3766V20.0576C15.454 20.3301 11 21.5064 11 22.9147C11 24.3231 15.454 25.4981 21.3766 25.7719V36H26.6436V25.7692C32.5567 25.4967 37 24.3217 37 22.9147C37 21.5077 32.5567 20.3328 26.6436 20.0589Z"
      fill="white"
    />
  </svg>
);

export const SkyCryptoLogo = () => (
  <svg
    width="222"
    height="56"
    viewBox="0 0 222 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15.8065C21 18.3646 20.1883 20.7246 18.8194 22.6205C19.8623 23.0817 20.8562 23.6357 21.7909 24.2721C23.3934 21.8729 24.3333 18.9544 24.3333 15.8065C24.3333 7.62908 17.9907 1 10.1667 1C8.71658 1 7.31737 1.22771 6 1.65078V27.1291C10.5833 27.5646 14.3175 29.0054 16 29.7387C19.9149 31.445 22.6667 35.4834 22.6667 40.1935C22.6667 46.4468 17.8164 51.5161 11.8333 51.5161C10.9729 51.5161 10.1359 51.4113 9.33333 51.2132V33.2259C8.03159 32.8857 7.30175 32.695 6 32.3549V53.6905C7.77895 54.5317 9.75382 55 11.8333 55C19.6574 55 26 48.3709 26 40.1935C26 34.5377 22.9659 29.6225 18.506 27.1291C17.0974 26.3415 14.5361 25.0399 9.33333 23.8497L9.33333 4.51688C9.60837 4.49501 9.88627 4.48388 10.1667 4.48388C16.1498 4.48388 21 9.55317 21 15.8065Z"
      fill="#0098DB"
    />
    <path
      d="M55.98 38.336C54.3933 38.336 52.9653 38 51.696 37.328C50.4453 36.656 49.5493 35.7973 49.008 34.752L51.108 33.184C52.284 34.9947 53.9267 35.9 56.036 35.9C57.1 35.9 57.9773 35.6387 58.668 35.116C59.3587 34.5747 59.704 33.8467 59.704 32.932C59.704 31.4013 58.752 30.2813 56.848 29.572L54.216 28.564C52.648 27.9853 51.5 27.2667 50.772 26.408C50.0627 25.5307 49.708 24.42 49.708 23.076C49.708 21.4707 50.2867 20.192 51.444 19.24C52.62 18.2693 54.1133 17.784 55.924 17.784C57.1373 17.784 58.248 18.036 59.256 18.54C60.264 19.0253 61.0853 19.6787 61.72 20.5L59.816 22.18C58.7147 20.8733 57.3987 20.22 55.868 20.22C54.86 20.22 54.0107 20.4813 53.32 21.004C52.6293 21.508 52.284 22.1613 52.284 22.964C52.284 23.7667 52.5173 24.4013 52.984 24.868C53.4507 25.3347 54.216 25.764 55.28 26.156L57.688 27.08C59.2187 27.6587 60.3667 28.4053 61.132 29.32C61.916 30.2347 62.308 31.4013 62.308 32.82C62.308 34.4813 61.7107 35.816 60.516 36.824C59.34 37.832 57.828 38.336 55.98 38.336ZM79.5479 38L68.9919 28.536V38H66.4159V18.12H68.9919V26.744L77.6719 18.12H81.0599L71.5959 27.584L83.2159 38H79.5479ZM90.9971 38V29.572L83.2691 18.12H86.3771L92.2851 26.968L98.2211 18.12H101.329L93.5731 29.6V38H90.9971ZM119.609 38.336C116.753 38.336 114.326 37.3467 112.329 35.368C110.332 33.3707 109.333 30.9347 109.333 28.06C109.333 25.1853 110.332 22.7587 112.329 20.78C114.326 18.7827 116.753 17.784 119.609 17.784C121.494 17.784 123.202 18.2133 124.733 19.072C126.264 19.9307 127.486 21.1067 128.401 22.6L126.217 23.916C125.508 22.7773 124.584 21.8813 123.445 21.228C122.306 20.5747 121.028 20.248 119.609 20.248C117.444 20.248 115.624 21.004 114.149 22.516C112.693 24.028 111.965 25.876 111.965 28.06C111.965 30.244 112.693 32.092 114.149 33.604C115.624 35.116 117.444 35.872 119.609 35.872C121.028 35.872 122.306 35.5453 123.445 34.892C124.584 34.2387 125.508 33.3427 126.217 32.204L128.401 33.52C127.486 35.0133 126.264 36.1893 124.733 37.048C123.202 37.9067 121.494 38.336 119.609 38.336ZM132.122 38V18.12H138.898C140.727 18.12 142.174 18.624 143.238 19.632C144.302 20.6213 144.834 21.9467 144.834 23.608C144.834 25.064 144.395 26.2587 143.518 27.192C142.659 28.1253 141.455 28.704 139.906 28.928L147.578 38H144.302L136.658 28.956H134.726V38H132.122ZM134.726 26.632H138.59C139.747 26.632 140.643 26.38 141.278 25.876C141.913 25.3533 142.23 24.5973 142.23 23.608C142.23 22.6187 141.913 21.8627 141.278 21.34C140.643 20.7987 139.747 20.528 138.59 20.528H134.726V26.632ZM154.844 38V29.572L147.116 18.12H150.224L156.132 26.968L162.068 18.12H165.176L157.42 29.6V38H154.844ZM179.479 19.912C180.748 21.1067 181.383 22.6187 181.383 24.448C181.383 26.2773 180.748 27.7893 179.479 28.984C178.228 30.16 176.585 30.748 174.551 30.748H171.079V38H168.475V18.12H174.551C176.585 18.12 178.228 18.7173 179.479 19.912ZM177.659 27.248C178.424 26.52 178.807 25.5867 178.807 24.448C178.807 23.3093 178.424 22.376 177.659 21.648C176.912 20.92 175.876 20.556 174.551 20.556H171.079V28.34H174.551C175.876 28.34 176.912 27.976 177.659 27.248ZM189.193 38V20.584H183.005V18.12H197.929V20.584H191.741V38H189.193ZM209.22 35.872C211.404 35.872 213.224 35.116 214.68 33.604C216.155 32.092 216.892 30.244 216.892 28.06C216.892 25.876 216.155 24.028 214.68 22.516C213.224 21.004 211.404 20.248 209.22 20.248C207.055 20.248 205.235 21.004 203.76 22.516C202.304 24.028 201.576 25.876 201.576 28.06C201.576 30.244 202.304 32.092 203.76 33.604C205.235 35.116 207.055 35.872 209.22 35.872ZM209.22 38.336C206.364 38.336 203.937 37.3467 201.94 35.368C199.943 33.3707 198.944 30.9347 198.944 28.06C198.944 25.1853 199.943 22.7587 201.94 20.78C203.937 18.7827 206.364 17.784 209.22 17.784C212.095 17.784 214.521 18.7827 216.5 20.78C218.497 22.7587 219.496 25.1853 219.496 28.06C219.496 30.9347 218.497 33.3707 216.5 35.368C214.521 37.3467 212.095 38.336 209.22 38.336Z"
      fill="#1D1D1D"
    />
  </svg>
);

export const CrossIcon = ({ size = 12, ...props }: IconProps) => (
  <svg style={{ width: size, height: size }} viewBox={'0 0 12 12'} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7071 1.70711C12.0976 1.31658 12.0976 0.683417 11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L6 4.58579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.58579 6L0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071C0.683417 12.0976 1.31658 12.0976 1.70711 11.7071L6 7.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L7.41421 6L11.7071 1.70711Z"
      fill="black"
      fillOpacity="0.24"
    />
  </svg>
);

const LikeIconRoot = styled.svg`
  width: ${(props) => px(props.size)};
  height: ${(props) => px(props.size)};
  &.flip {
    transform: scaleY(-1);
    margin-top: -0.2vh;
  }
`;
const ShieldIconSvg = styled.svg`
  width: ${(props) => px(props.size)};
  height: ${(props) => px(props.size)};
  background: 50% url(/logo.png) no-repeat;
  background-size: 25%;
`;
